var singelton = null

export default class Geo {
  constructor (options) {
    if (typeof options == "undefined") {
      options = {};
    }
    // function to call when location is made avalible

    if (options['on_success']) {
      this.on_success_callback = options['on_success'].bind(this)
    }
    if (options['on_request']) {
      this.on_request_callback = options['on_request'].bind(this)
    }
    if (options['on_failure']) {
      this.on_failure_callback = options['on_failure'].bind(this)
    }
    if (options['position']) {
      this.default_position = options['position'];
    }


    if (singelton) {
      // Only allow initilization code to run once.
      return singelton;
    }

    this.latCookie = new Foundation.Cookie('gyrobase-latitude')
    this.longCookie = new Foundation.Cookie('gyrobase-longitude')

    // set this for use in the handleQuery function
    this.isFirstRun = "true";

    // If a position is passed to this function use this as the default
    if (typeof this.default_position != "undefined") {
      var position = this.default_position;
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      this.execute_callbacks(this.on_success_callback);
    }
    else {
      // Initialize the geolocation
      this.gl = navigator.geolocation;

      if (!this.gl) {
        this.locationUnavailable = true;
        this.execute_callbacks(this.on_failure_callback);
      }
    }

    singelton = this;
  }


  execute_callbacks (callback, arg) {
    if (typeof callback == "function") {
      callback.call(this, arg);
    }
  }


  updatePosition () {
    if (this.defaultPosition) {
      // default position is being used so jump straigth to the handler.
      this.handleQuery(this.defaultPosition);
    }
    else {
      if (this.latCookie.getValue('gyrobase-latitude')) {
        // the cookies have not timed out and so we don't need to query the location
        var stale_pos = {}
        stale_pos.coords = {}
        stale_pos.coords.latitude = this.latCookie.getValue()
        stale_pos.coords.longitude = this.longCookie.getValue() 

        this.handleQuery(stale_pos);
      }
      else {
        this.getPosition()
      }
    }
    this.isFirstRun = false
  }


  getPosition () {
    this.execute_callbacks(this.on_request_callback);
    if (this.gl) {
      this.gl.getCurrentPosition(this.handleQuery.bind(this), this.handleError.bind(this))
    }
    else {
      this.locationAvalible = false;
      this.execute_callbacks(this.on_failure_callback, {code: 2});
    }
  }


  handleQuery (position) {
    this.latitude = position.coords.latitude;
    this.longitude = position.coords.longitude;
    this.locationAvalible = true;

    this.latCookie.setValueAndSave(this.latitude)
    this.longCookie.setValueAndSave(this.longitude)

    this.execute_callbacks(this.on_success_callback, position);
  }


  handleError (error) {
    this.locationAvalible = false;
    this.execute_callbacks(this.on_failure_callback, error);
  }
}

window["Foundation"]["Geo"] = Geo
